<template>

  <button  @click='process' type="submit" class="btn btn-success btn-md">
    <slot></slot>
  </button>
</template>
<script>
  export default {
    name:'submitButton',
    props:{
      dataLoadingText:{
        default:"<i class='icon-spinner icon-spin icon-large'></i> Processing..."
      },
    },
    data(){
      return {
        text:"",
        el:null
      }
    },
    created(){
      console.log("button creaetd");
      event.$on("loadingFinished",()=>{
        if(this.el){
          this.el.innerHTML =this.text
          this.el.disabled = false
        }
      })
    },
    methods:{
      process(e){
        // add here loading
        this.text = e.target.innerText;
        e.target.innerHTML = this.dataLoadingText
        console.log(this.dataLoadingText);
        e.target.disabled= true
        this.$emit("click", e)
        this.el = e.target
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/submitButton.vue